import React from 'react';
import { GestureResponderEvent, StyleSheet } from 'react-native';
import { ActivityIndicator, ErrorMessageRetryBackdrop } from '..';

const styles = StyleSheet.create({
  contentView: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export const DefensiveView = (props: DefensiveViewProps) => {
  if (props.isRefreshing) {
    return props.children;
  } else if (props.isFetching) {
    return <ActivityIndicator style={styles.contentView} />;
  } else if (props.isFailure) {
    return props.fetchData ? <ErrorMessageRetryBackdrop onRetry={props.fetchData} /> : <ErrorMessageRetryBackdrop />;
  }

  return props.children;
};

interface DefensiveViewProps {
  children: any;
  fetchData?: (event: GestureResponderEvent) => void;
  isFailure: boolean;
  isFetching: boolean;
  isRefreshing?: boolean;
}
